<template>
  <div class="form-user">
    <div class="content-layout content-layout--passcode">
      <header class="modal-card-head"><p class="modal-card-title">Thêm người dùng</p><button aria-label="close" class="delete" @click="$emit('hide-modal',false)"></button></header>
      <div class="content-layout__inner">
        <form @submit.prevent="validateBeforeSubmit">
          <b-field
            :type="{'is-danger': errors.has('username')}"
            :message="errors.first('username')"
            custom-class="has-text-weight-normal body-text"
          >
            <template slot="label">
              Tài khoản <span class="has-text-danger">*</span>
            </template>
            <b-input
              v-model="username"
              name="username"
              v-validate="{required: true, regex: /[^:]*/}"
              size="is-medium"
              ref="username"
              data-vv-as="Tài khoản"
            />
          </b-field>

          <b-field
            :type="{'is-danger': errors.has('firstName')}"
            :message="errors.first('firstName')"
            custom-class="has-text-weight-normal body-text"
          >
            <template slot="label">
              Tên <span class="has-text-danger">*</span>
            </template>
            <b-input
              v-model="firstName"
              name="firstName"
              v-validate="'required'"
              size="is-medium"
              data-vv-as="Tên"
            />
          </b-field>

          <b-field
            :type="{'is-danger': errors.has('lastName')}"
            :message="errors.first('lastName')"
            custom-class="has-text-weight-normal body-text"
          >
            <template slot="label">
              Họ <span class="has-text-danger">*</span>
            </template>
            <b-input
              v-model="lastName"
              name="lastName"
              v-validate="'required'"
              size="is-medium"
              data-vv-as="Họ"
            />
          </b-field>

          <!--<b-field
            label="Email"
            :type="{'is-danger': errors.has('email')}"
            :message="errors.first('email')"
          >
            <b-input
              v-model="email"
              placeholder="Email"
              name="email"
              v-validate="'required|email'"
              size="is-medium"
            ></b-input>
          </b-field>-->

          <b-field
            label="Mật khẩu"
            :type="{'is-danger': errors.has('password')}"
            :message="errors.first('password')"
            custom-class="has-text-weight-normal body-text"
          >
            <template slot="label">
              Mật khẩu <span class="has-text-danger">*</span>
            </template>
            <b-input
              v-model="password"
              type="password"
              name="password"
              v-validate="{required: true, regex: /\w/, min: 8}"
              size="is-medium"
              data-vv-as="Mật khẩu"
            />
          </b-field>

          <b-field
            label="Xác nhận mật khẩu"
            :type="{'is-danger': errors.has('confirm-password')}"
            :message="errors.first('confirm-password')"
            custom-class="has-text-weight-normal body-text"
          >
            <template slot="label">
              Xác nhận mật khẩu <span class="has-text-danger">*</span>
            </template>
            <b-input
              v-model="confirmPassword"
              v-validate="{ required: true, is: password }"
              type="password"
              name="confirm-password"
              size="is-medium"
              data-vv-as="Xác nhận mật khẩu"
            />
          </b-field>

          <div class="field is-grouped is-grouped-centered">
            <div class="control">
              <button type="submit" class="button is-info">Thêm</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>

<script>
import ParticipantService from "@/services/ParticipantService";

export default {
  name: "NewUser",
  data() {
    return {
      username: "",
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: ""
    };
  },
  methods: {
    createParticipant() {
      ParticipantService.createParticipant(
        {
          user: {
            username: this.username,
            firstName: this.firstName,
            // lastName: `${this.$store.state.auth.entityTag}-${this.lastName}`,
            lastName: this.lastName,
            password: this.password,
            email: this.username + '@nvvcroom-core.viettel.vn'
          },
          userOwner: this.currentUser
        },
        this.$store.state.auth.token
      )
        .then(res => {
          if (res.data.status) {
            this.$toast.open({
              message: res.data.message,
              type: "is-info"
            });
            this.resetData();
            this.$nextTick(() => {
              this.$validator.reset();
            });

            setTimeout(function(){
              location.reload();
            }, 1000)
          } else {
            let errMessage = res.data.message;
            if(res.data.message.includes('Valid Email Address is required')) {
              errMessage = "Email không hợp lệ";
            }
            this.$toast.open({
              message: errMessage,
              type: "is-danger",
            });
          }
        })
        .catch(() => {
          this.$toast.open({
            message: "Lỗi máy chủ. Vui lòng thử lại",
            type: "is-info"
          });
        });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createParticipant();
          return;
        }
      });
    },
    resetData() {
      this.username = "";
      this.firstName = "";
      this.lastName = "";
      this.password = "";
      this.confirmPassword = "";
    }
  },
  props: {
    currentUser: {
      type: String,
      default: null
    },
    isParentShowAddUser: {
      type: Boolean
    }
  },
  watch: {
    isParentShowAddUser() {
      if(this.isParentShowAddUser) {
        this.$refs.username.$el.querySelector('input').focus()
      }
    }
  }
};
</script>

<style lang="scss" scope>
  .form-user {
    padding: 0 2rem;
    border-radius: 5px;
  }
  .form-user.padding-space {
    padding: 2rem;
  }
</style>